import { useMutation } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';

import { updateUser } from '@/stores/auth.store';

import { verifyEmail } from '../api/auth.api';

export function useVerifyEmail() {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (token: string) => verifyEmail(token),
    onSuccess: (response) => {
      updateUser(response.user);
      toast.success(response.message);
      const destination = response.user.accountSetupComplete ? '/' : '/account-setup';
      navigate({ to: destination });
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Verification failed. Please try again.');
    },
  });
}
